import loadScript from '@/azure/loader';
import { initErrorHandler } from '@/azure/error/handler';

loadScript(initErrorHandler);
